import { v4 as uuid } from "uuid";

/**
 * Size set quantities into a WO product's sizes (user, 2026-10-30).
 *
 * productSizes  the product's sizes: the formData JSON string or an array of
 *               { id, size, quantity, price, cost, sortId }
 * entries       [{ size, quantity, price }] typed in the size set modal;
 *               only the ones with a quantity are used
 *
 * A size already on the product (any case) takes the typed quantity and
 * price; any other is added after the sizes already there. Returns
 * { sizes, totalQuantity, totalPrice }.
 */
export const mergeSetSizes = (productSizes, entries) => {
  let sizes = [];
  try {
    sizes =
      typeof productSizes === "string"
        ? JSON.parse(productSizes || "[]")
        : [...(productSizes || [])];
  } catch {
    sizes = [];
  }
  let next = sizes.reduce((m, s) => Math.max(m, Number(s.sortId) || 0), 0);
  (entries || []).forEach(({ size, quantity, price }) => {
    const qty = parseInt(quantity, 10);
    const name = String(size || "").trim().toUpperCase();
    if (!name || !(qty > 0)) return;
    const unit = parseFloat(price);
    const row = {
      size: name,
      quantity: qty,
      price: Number.isFinite(unit) ? unit : "",
      cost: (Number.isFinite(unit) ? unit : 0) * qty,
    };
    const at = sizes.findIndex(
      (s) => String(s.size || "").trim().toUpperCase() === name,
    );
    if (at >= 0) sizes[at] = { ...sizes[at], ...row, size: sizes[at].size };
    else sizes.push({ ...row, id: uuid(), sortId: ++next });
  });
  const totals = sizes.reduce(
    (acc, s) => {
      const qty = parseInt(s.quantity, 10) || 0;
      acc.totalQuantity += qty;
      acc.totalPrice += qty * (parseFloat(s.price) || 0);
      return acc;
    },
    { totalQuantity: 0, totalPrice: 0 },
  );
  return { sizes, ...totals };
};
